<template>
    <div class="hamburger" :class="{'open': isDropmenu, 'subpage': isSubpage}" :style="{ 'background': activeColor }">
        <div class="hamburger__items">
            <span class="hamburger__item"></span>
            <span class="hamburger__item"></span>
            <span class="hamburger__item"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Hamburger",
    props: {
        isDropmenu: {
            type: Boolean,
            default: false
        },
        isSubpage: {
            type: Boolean,
            default: false
        },
        activeColor: {
            type: String,
            default: 'white'
        }
    }
};
</script>
